import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const Kazei = props => {
  return <Dropdown.Static kubunKey='kazei' {...props} />
}
